import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { translate } from './translations';

const LanguageContext = createContext({
  language: 'en',
  setLanguage: () => {},
  t: (key) => key
});

export const LANGUAGES = [
  { code: 'en', short: 'ENG', native: 'English' },
  { code: 'hi', short: 'हिंदी', native: 'हिंदी' },
  { code: 'zh', short: '中文', native: '中文' },
  { code: 'es', short: 'ES', native: 'Español' }
];

const STORAGE_KEY = 'appLanguage';

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEY);
    return LANGUAGES.some((item) => item.code === saved) ? saved : 'en';
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, language);
    document.documentElement.lang = language === 'zh' ? 'zh-CN' : language;
  }, [language]);

  const value = useMemo(() => ({
    language,
    setLanguage: (code) => {
      if (LANGUAGES.some((item) => item.code === code)) {
        setLanguageState(code);
      }
    },
    t: (key, vars) => translate(language, key, vars)
  }), [language]);

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
